import React, { useEffect, useRef } from 'react';
import PremiumSectionContainer from '../../ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../../ticketForm/components/PremiumSection';
import { InfoMessage } from '../../ticketForm/components/InfoMessage';

export const QuoteFormErrorInfoBlock = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    // ref.current?.scrollIntoView();
  }, []);

  return (
    <PremiumSectionContainer ref={ref} {...props}>
      <PremiumSection>
        <InfoMessage>{props.backendErrorsMsg}</InfoMessage>
      </PremiumSection>
    </PremiumSectionContainer>
  );
};
